import lazyWithRetry from 'utils/lazyWithRetry';
import Loadable from 'components/Loadable';

const FirebaseAuthAction = Loadable(lazyWithRetry(() => import('pages/auth/firebase/action')));

const PublicRoutes = {
  path: '/',
  children: [
    // ✅ Public Firebase email action handler route
    { path: 'action', element: <FirebaseAuthAction /> }
  ]
};

export default PublicRoutes;
